import React, { useState, useEffect, useCallback } from "react";
import * as SC from "./styled";
import Menu from "./menu";
import data from "@assets/json/menu.json";
import { useDimensions } from "@utils/dimensions";

const Link = ({ data }) =>
  data.target ? (
    <SC.NavExternalLink href={data.url} target={data.target}>
      {data.name}
    </SC.NavExternalLink>
  ) : (
    <SC.NavDirectLink to={data.url}>{data.name}</SC.NavDirectLink>
  );

const NavLink = ({ children, ...rest }) => (
  <SC.NavLinkContainer {...rest}>
    <SC.NavLink>{children}</SC.NavLink>
    <SC.NavIcon />
  </SC.NavLinkContainer>
);

const Header = () => {
  const [menuIndex, setMenuIndex] = useState(false);
  const [menuItems, setMenuItems] = useState(data);
  const { isMobile } = useDimensions();

  useEffect(() => {
    if (isMobile) {
      const updated = [data[0], { name: "Menu", items: data.slice(1) }];
      if (menuIndex > 0) setMenuIndex(1);
      handleMenuItems(updated);
    } else {
      handleMenuItems(data);
    }
  }, [isMobile]);

  const handleMenuItems = useCallback(
    items => {
      setMenuItems(items);
    },
    [menuIndex, isMobile]
  );

  const handleMenu = index => {
    const updated = menuIndex === index ? false : index;
    setMenuIndex(updated);
  };

  return (
    <>
      <SC.Container>
        <SC.LogoLink to="/">
          <SC.Logo alt="Tonic3" />
        </SC.LogoLink>

        <SC.Nav>
          {menuItems.map((item, i) =>
            item.url ? (
              <Link data={item} />
            ) : (
              <NavLink
                key={i}
                active={menuIndex === i}
                onClick={() => handleMenu(i)}
              >
                {item.name}
              </NavLink>
            )
          )}
        </SC.Nav>
      </SC.Container>

      {menuIndex !== false && <Menu data={menuItems[menuIndex]} />}
    </>
  );
};

export default Header;
